import workOrderService from './ws';

export default workOrderService;